export const transformToMondaySiteName = ({ slug }: { slug: string }): string =>
	`https://${slug}.monday.com`;
